
const GMEET_ICON_URI = "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png";
const SKYPE_ICON_URI = "/assets/skypeIcon.svg"; // Assuming this is a local asset

export const OQLOUS_STANDARD_EVENT = {
  title: "Untitled Event",
  date: "",
  startTime: "",
  endTime: "",
  location: "",
  organizer: "You",
  description: "No description available",
  meetLink: "",
  attachments: [],
  attendees: [],
  reminders: "",
  meetIconUrl: "",
};

/**
 * Formats an ISO 8601 string into separate date (YYYY-MM-DD) and time (HH:mm) strings.
 */
const formatForInput = (isoString) => {
  if (!isoString) {
    return { date: "", time: "" };
  }
  const dateObj = new Date(isoString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const formattedTime = `${hours}:${minutes}`;
  return { date: formattedDate, time: formattedTime };
};

/**
 * Maps raw event details from a tool's arguments to a standardized UI-friendly format.
 */
export const mapEventData = (eventDetails, functionName, approvalNeeded = false) => {
  if (!eventDetails || !functionName) return { ...OQLOUS_STANDARD_EVENT };

  if (approvalNeeded) {
    const startTimes = formatForInput(eventDetails.start_time);
    const endTimes = formatForInput(eventDetails.end_time);

    if (functionName === "create_google_calendar_event") {
      return {
        title: eventDetails.summary || "Autogenerate Event",
        date: startTimes.date,
        startTime: startTimes.time,
        endDate: endTimes.date,
        endTime: endTimes.time,
        location: eventDetails.location || "",
        organizer: "You",
        description: eventDetails.description || "No description available",
        attendees: eventDetails.attendees_emails || [],
        meetLink: eventDetails.include_meet_link ? "Google Meet link will be generated" : "",
        meetIconUrl: eventDetails.include_meet_link ? GMEET_ICON_URI : "",
      };
    } else if (functionName === "create_calendar_event_outlook" || functionName === "update_calendar_event") {
      let location = eventDetails.location || "";
      if (eventDetails.is_online_meeting && !location) {
        location = "Microsoft Teams Meeting";
      }

      return {
        title: eventDetails.subject || "Autogenerate Event",
        date: startTimes.date,
        startTime: startTimes.time,
        endDate: endTimes.date,
        endTime: endTimes.time,
        location: location,
        organizer: "You",
        attendees: eventDetails.required_attendees || [],
        description: eventDetails.body_content || "No description available",
        meetLink: eventDetails.is_online_meeting ? "skype link will be generated" : "",
        meetIconUrl: eventDetails.is_online_meeting ? SKYPE_ICON_URI : "",
      };
    }
  }
  return { ...OQLOUS_STANDARD_EVENT };
};

/**
 * Unmaps the UI event state back to the tool's specific argument format.
 */
export const unmapEventData = (event, functionName, originalArgs = {}) => {
  const toISOString = (date, time) => {
    if (!date || !time) return null;
    return new Date(`${date}T${time}`).toISOString();
  };

  const startTimeISO = toISOString(event.date, event.startTime);
  const endTimeISO = toISOString(event.endDate || event.date, event.endTime);
  
  const updatedFields = {
    start_time: startTimeISO,
    end_time: endTimeISO,
    location: event.location,
  };

  if (functionName === "create_google_calendar_event") {
    return {
      ...originalArgs,
      summary: event.title,
      description: event.description,
      attendees_emails: event.attendees,
      ...updatedFields
    };
  }

  if (functionName === "create_calendar_event_outlook" || functionName === "update_calendar_event") {
    return {
      ...originalArgs,
      subject: event.title,
      body_content: event.description,
      required_attendees: event.attendees,
      ...updatedFields
    };
  }
  
  return {};
};